import { Component, inject, Renderer2 } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FooterTermsOfUsePopupComponent } from './footer-terms-of-use-popup/footer-terms-of-use-popup.component';
import { FooterPrivacyPolicyPopupComponent } from './footer-privacy-policy-popup/footer-privacy-policy-popup.component';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent {
  renderer = inject(Renderer2);
  matDialog = inject(MatDialog);

  ngAfterViewInit() {
    this.renderer.listen('document', 'click', (event) => {



      //to get button with className
      const clickedInside = (event.target as HTMLElement).className;
      // termsAndConditionsLinks is the classname of the terms of use POPUP
      if (clickedInside.includes('termsAndConditionsLinks')) {
        //Need to call terms of use Popup
        this.matDialog.open(FooterTermsOfUsePopupComponent);
      }
      // dataprotection is the classname of the Privacy Policies POPUP
      if (clickedInside.includes('dataprotection')) {
        //Need to call Privacy Policies Popup
        this.matDialog.open(FooterPrivacyPolicyPopupComponent);
      }

    });
  }
}
